




















import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import NoteBox from "@/basics/boxes/NoteBox.vue";
import UploadCsvFile, {
  UploadEvent
} from "@/components/inputs/UploadCsvFile.vue";
import { createGroupBuildings } from "@/graphql/mutation/createGroupBuildings";

@Component({
  components: {
    CButton,
    NoteBox,
    UploadCsvFile
  }
})
export default class BuildingsNew extends Vue {
  errors: Error[] = [];

  get isIE(): boolean {
    const ua: string = window.navigator.userAgent.toLowerCase();
    if (ua.match(/trident\/7/)) {
      return true;
    }
    return false;
  }

  async upload({ text }: UploadEvent) {
    const result = await createGroupBuildings(
      this.$apollo,
      this.$route.params.groupId,
      text!
    );
    if (result.errors) {
      alert("登録できませんでした。" + result.errors[0].message);
      return;
    }

    alert("登録しました");
    this.$router.push({ name: "buildings-list" });
  }
}
